import { render, staticRenderFns } from "./noticeUploadInsuranceTemplate.vue?vue&type=template&id=effb564e"
import script from "./noticeUploadInsuranceTemplate.vue?vue&type=script&lang=js"
export * from "./noticeUploadInsuranceTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('effb564e')) {
      api.createRecord('effb564e', component.options)
    } else {
      api.reload('effb564e', component.options)
    }
    module.hot.accept("./noticeUploadInsuranceTemplate.vue?vue&type=template&id=effb564e", function () {
      api.rerender('effb564e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/message/noticeUploadInsuranceTemplate.vue"
export default component.exports